// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","FilterForm__hgroup":"ot_a bhu_a bhu_x","FilterForm__vgroup":"ot_b bhu_rp"};